<script>
import { CustomMenu } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit Custom Menu',
      addRoute: { name: 'Add Custom Menu' },
      verboseName: 'Niestandardowe Menu',
      verboseNamePlural: 'Niestandardowe Menu',
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'name', label: 'nazwa robocza' }
      ]
    }
  },
  computed: {
    service() {
      return CustomMenu
    }
  }
}
</script>
